
import axios from 'axios';

// The backend structure requires the /api prefix before all module endpoints
export const API_BASE_URL = 'https://api.aicryptoworlds.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor to attach JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor to handle session expiration and formatting
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_role');
      window.location.hash = '/login';
    }
    // Extract message from response if available
    const message = error.response?.data?.message || 'Unable to connect to server';
    return Promise.reject(new Error(message));
  }
);

export default api;
